import React, { FC, useState } from 'react';
import { useGetProgramMasterData } from 'src/api/mutations/useGetProgramMasterData';
import './IncreaseStrengthSteps.scss';
import { ReactComponent as Low_impact_strengthening_rehabilitationIcon } from '../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/low_impact_strengthening_rehabilitation.svg';
import { ReactComponent as Return_to_movement_rehabilitationIcon } from '../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/return_to_movement_rehabilitation.svg';
import { ReactComponent as Return_to_strength_rehabilitationIcon } from '../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/return_to_strength_rehabilitation.svg';
import { ReactComponent as Mobility_stability_rehabilitationIcon } from '../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/mobility_stability_rehabilitation.svg';

interface RehabilitationStep3Props {
  value?: string;
  onNext?: (value: string) => void;
}

const iconMap: Record<string, React.ReactNode> = {
  return_to_movement: <Return_to_movement_rehabilitationIcon />,
  return_to_strength: <Return_to_strength_rehabilitationIcon />,
  mobility_stability: <Mobility_stability_rehabilitationIcon />,
  low_impact_strengthening: <Low_impact_strengthening_rehabilitationIcon />,
};

// How should this goal be approached?
// Choose the training type that best suits your client
export const RehabilitationStep3: FC<RehabilitationStep3Props> = ({ value, onNext }) => {
  const [selectedApproach, setSelectedApproach] = useState<string>(value || '');
  const { data: programMasterData, isLoading, isError } = useGetProgramMasterData();

  const groupData = programMasterData?.trainingGoalApproaches?.groups?.find(
    (g: any) => g.goalId === 'rehabilitation',
  );

  const approaches = groupData?.options
    ? [...groupData.options].sort((a: any, b: any) => a.order - b.order)
    : [];

  if (isLoading) {
    return <div className="increase-strength-step">{'Loading options...'}</div>;
  }

  if (isError || !groupData) {
    return <div className="increase-strength-step">{'Error loading options.'}</div>;
  }

  return (
    <div className="increase-strength-step">
      <h2 className="step-title">{groupData?.title}</h2>
      <p className="step-subtitle">{groupData?.subtitle}</p>

      <div className="goal-buttons">
        {approaches.map((approach: any) => (
          <button
            key={approach.id}
            className={`goal-btn ${selectedApproach === approach.slug ? 'selected' : ''}`}
            onClick={() => {
              setSelectedApproach(approach.slug);
              if (onNext) onNext(approach.slug);
            }}
          >
            <div className="goal-icon">{iconMap[approach.id]}</div>
            <span className="goal-label">{approach.title}</span>
          </button>
        ))}
      </div>
    </div>
  );
};
